import {
  ADDON_PROJECTS,
  ALLOWED_CREDIT_BLOCK_VALUES,
  CREDITS_PER_BLOCK,
  PLAN_INTERVAL,
} from './../constants';
import { PlanAddOn } from '../records/Plan';
import { SubscriptionAddOn } from '../records/Subscription';

/**
 * Returns the number of API Testing allowed monthly executions for a plan with given projectsCount
 * @param {?number} projectsCount
 * @returns {?number}
 */
export const projectsToMonthlyExecutions = (
  projectsCount: number | null,
  add_ons: (PlanAddOn|SubscriptionAddOn)[], // eslint-disable-line camelcase
): number => {
  const projectsAddOn = add_ons.find((addOn) => addOn.code === ADDON_PROJECTS);
  if (!Number.isFinite(projectsCount) || !projectsAddOn) {
    return 0;
  }
  return projectsAddOn.monthly_executions_map[projectsCount as number];
};

export interface SuggestedCreditBlocks {
  annual: number,
  monthly: number,
}

/**
 * Returns the suggested number of blocks to upgrade a credits plan to, both monthly and annual,
 * based on currently owned blocks and average monthly usage.
 * @param {number} currentSubscriptionBlocks
 * @param {number} averageMonthlyUsage
 * @returns {SuggestedCreditBlocks}
 */
export const suggestedCreditBlocksToBuy = (
  currentSubscriptionBlocks: number,
  averageMonthlyUsage: number,
): SuggestedCreditBlocks => {
  const fullBlocksUsedOnAverage = Math.floor((averageMonthlyUsage || 0) / CREDITS_PER_BLOCK);
  const currentMonthlyBlocks: number = (currentSubscriptionBlocks % 12 === 0) ?
    currentSubscriptionBlocks / 12 :
    currentSubscriptionBlocks;
  const defaultMonthlyBlocks = Math.max(fullBlocksUsedOnAverage, currentMonthlyBlocks);

  return {
    annual: ALLOWED_CREDIT_BLOCK_VALUES[PLAN_INTERVAL.YEAR].find(
      (blocks) => blocks > 12 * defaultMonthlyBlocks,
    ) || ALLOWED_CREDIT_BLOCK_VALUES[PLAN_INTERVAL.YEAR].slice(-1)[0],
    monthly: ALLOWED_CREDIT_BLOCK_VALUES[PLAN_INTERVAL.MONTH].find(
      (blocks) => blocks > defaultMonthlyBlocks,
    ) || ALLOWED_CREDIT_BLOCK_VALUES[PLAN_INTERVAL.MONTH].slice(-1)[0],
  };
};
